import operasionalService from "../../services/operasionalService/service";
import operasionalModel from "../../models/operasionalModel/model";
export default {
    async fetchOperasional(search, page, limit, company){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await operasionalService.getOperasional(sanitizedSearch, page, limit, company);
            return {
                data: data.map(operasional => new operasionalModel(operasional)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching operasional:', error);
            throw error;
        }
    },
    async totalALlOperasional(seearch, company){
        try{
            const sanitizedSearch = seearch && seearch.trim() !== '' ? seearch : null;
            return await operasionalService.totalAllOperasional(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching operasional:', error);
            throw error;
        }
    },
    async addOperasional(operasional){
        try {
            return await operasionalService.addOperasional(operasional);
        } catch (error) {
            console.error('Error adding operasional:', error);
            throw error;
        }
    },
    async updateOperasional(operasional){
        try {
            return await operasionalService.updateOperasional(operasional);
        } catch (error) {
            console.error('Error updating operasional:', error);
            throw error;
        }
    },
    async deleteOperasional(id){
        try {
            return await operasionalService.deleteOperasional(id);
        } catch (error) {
            console.error('Error deleting operasional:', error);
            throw error;
        }
    }
}